(function () {
  'use strict';

  var quickViewTrigger = null;
  var quickViewEventsBound = false;
  var quickViewCartTransitionTimer = null;
  var quickViewCartTransitionAttempts = 0;

  function focusableElements(container) {
    if (!container) return [];
    return Array.prototype.slice.call(container.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(function (element) {
      return element.offsetWidth > 0 || element.offsetHeight > 0;
    });
  }

  function initDescription(collection) {
    var wrap = collection.querySelector('[data-bpc-description-wrap]');
    if (!wrap || wrap.getAttribute('data-bpc-bound') === 'true') return;

    var content = wrap.querySelector('[data-bpc-description-content]');
    var toggle = wrap.querySelector('[data-bpc-description-toggle]');
    if (!content || !toggle) return;

    wrap.setAttribute('data-bpc-bound', 'true');

    window.requestAnimationFrame(function () {
      var lineHeight = parseFloat(window.getComputedStyle(content).lineHeight) || 27;
      if (content.scrollHeight <= lineHeight * 3.4) return;

      content.setAttribute('data-collapsed', 'true');
      toggle.hidden = false;
    });

    toggle.addEventListener('click', function () {
      var isExpanded = toggle.getAttribute('aria-expanded') === 'true';
      var label = toggle.querySelector('[data-bpc-description-label]');
      var symbol = toggle.querySelector('[aria-hidden="true"]');

      toggle.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
      content.setAttribute('data-collapsed', isExpanded ? 'true' : 'false');
      if (label) label.textContent = isExpanded ? 'Read more' : 'Read less';
      if (symbol) symbol.textContent = isExpanded ? '+' : '−';
    });
  }

  function initCollectionSubnav(collection) {
    var list = collection.querySelector('.bpc-collection-subnav__list');
    var current = list ? list.querySelector('[aria-current="page"]') : null;

    if (!list || !current || list.getAttribute('data-bpc-positioned') === 'true') return;
    list.setAttribute('data-bpc-positioned', 'true');

    window.requestAnimationFrame(function () {
      var maximum = Math.max(0, list.scrollWidth - list.clientWidth);
      var target = current.offsetLeft - ((list.clientWidth - current.offsetWidth) / 2);

      if (maximum > 0) {
        list.scrollLeft = Math.max(0, Math.min(maximum, target));
      }
    });
  }

  function convertPrices(roots) {
    if (!window.Currency || !window.shopCurrency || !window.Currency.currentCurrency) return;
    if (window.Currency.currentCurrency === window.shopCurrency) return;

    roots.forEach(function (root) {
      var prices = root.querySelectorAll('span.money');
      if (prices.length) window.Currency.convertAll(window.shopCurrency, window.Currency.currentCurrency, prices);
    });
  }

  function revealImages(items) {
    convertPrices(items);
    if (!window.lazySizes || !window.lazySizes.loader) return;
    items.forEach(function (item) {
      item.querySelectorAll('.lazyload').forEach(function (image) {
        window.lazySizes.loader.unveil(image);
      });
    });
  }

  function refreshReviewWidgets() {
    try {
      if (window.SPR) {
        if (window.SPR.initDomEls) window.SPR.initDomEls();
        if (window.SPR.loadBadges) window.SPR.loadBadges();
      }
      if (window.yotpo && window.yotpo.refreshWidgets) window.yotpo.refreshWidgets();
    } catch (error) {
      /* Review integrations remain non-blocking if an app is unavailable. */
    }
  }

  function hasLegacyCatalogPricing() {
    if (!window.BOLD || !window.BOLD.apps_installed) return false;
    var installed = typeof window.BOLD.apps_installed === 'string'
      ? window.BOLD.apps_installed
      : JSON.stringify(window.BOLD.apps_installed);
    return /(Customer Pricing|Product Bundles|Product Discount|Quantity Breaks|Custom Order)/i.test(installed);
  }

  function initLoadMore(collection) {
    var results = collection.querySelector('[data-bpc-collection-results]');
    var grid = collection.querySelector('[data-bpc-product-grid]');
    var controls = collection.querySelector('[data-bpc-collection-controls]');
    var nextLink = collection.querySelector('[data-bpc-collection-next]');
    var status = collection.querySelector('[data-bpc-collection-status]');
    if (!results || !grid || !controls || !nextLink || nextLink.getAttribute('data-bpc-bound') === 'true') return;

    if (hasLegacyCatalogPricing()) {
      var compatibilityLabel = nextLink.querySelector('[data-bpc-collection-next-label]');
      if (compatibilityLabel) compatibilityLabel.textContent = 'Next 48 products';
      nextLink.setAttribute('title', 'Open the next 48 products');
      return;
    }

    var loading = false;
    nextLink.setAttribute('data-bpc-bound', 'true');

    function setLoading(value) {
      var label = nextLink.querySelector('[data-bpc-collection-next-label]');
      var spinner = nextLink.querySelector('[data-bpc-collection-spinner]');
      loading = value;
      nextLink.setAttribute('aria-busy', value ? 'true' : 'false');
      if (label) label.textContent = value ? 'Loading products' : 'Load more products';
      if (spinner) spinner.hidden = !value;
    }

    nextLink.addEventListener('click', function (event) {
      if (nextLink.getAttribute('aria-disabled') === 'true') {
        event.preventDefault();
        return;
      }
      if (loading || !nextLink.href) return;
      event.preventDefault();
      setLoading(true);

      fetch(nextLink.href, {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Collection request failed');
          return response.text();
        })
        .then(function (html) {
          var page = new DOMParser().parseFromString(html, 'text/html');
          var sourceResults = page.querySelector('[data-bpc-collection-results]');
          var sourceStatus = page.querySelector('[data-bpc-collection-status]');
          var sourceNext = page.querySelector('[data-bpc-collection-next]');
          if (!sourceResults) throw new Error('Collection results markup missing');

          var newItems = Array.prototype.slice.call(sourceResults.querySelectorAll('[data-bpc-collection-item]'));
          var appendedItems = [];
          newItems.forEach(function (item) {
            var appended = document.importNode(item, true);
            grid.appendChild(appended);
            appendedItems.push(appended);
          });

          revealImages(appendedItems);
          refreshReviewWidgets();
          if (window.BpcInitQuickView) window.BpcInitQuickView();
          if (window.jQuery && window.jQuery.fn.matchHeight && window.jQuery.fn.matchHeight._update) {
            window.jQuery.fn.matchHeight._update(true);
          }

          if (status && sourceStatus) {
            var pageStart = parseInt(status.getAttribute('data-page-start'), 10) || 1;
            var totalProducts = sourceStatus.getAttribute('data-total-products') || status.getAttribute('data-total-products') || '';
            var displayedProducts = pageStart - 1 + grid.querySelectorAll('[data-bpc-collection-item]').length;
            status.textContent = newItems.length + ' more products loaded. Showing ' + pageStart + '-' + displayedProducts + ' of ' + totalProducts + ' products.';
          }

          if (sourceNext) {
            nextLink.href = sourceNext.href;
            setLoading(false);
          } else {
            var label = nextLink.querySelector('[data-bpc-collection-next-label]');
            var spinner = nextLink.querySelector('[data-bpc-collection-spinner]');
            loading = false;
            nextLink.removeAttribute('href');
            nextLink.removeAttribute('aria-busy');
            nextLink.setAttribute('aria-disabled', 'true');
            if (label) label.textContent = 'All products loaded';
            if (spinner) spinner.hidden = true;
          }
        })
        .catch(function () {
          setLoading(false);
          var label = nextLink.querySelector('[data-bpc-collection-next-label]');
          if (label) label.textContent = 'Try loading again';
          if (status) status.textContent = 'More products could not be loaded. Use the button to try again.';
        });
    });
  }

  function enhanceQuickView() {
    var popup = document.querySelector('.mfp-wrap .quick-view-panel');
    if (!popup) return;

    var dialog = popup.closest('.mfp-dialog') || popup;
    var close = document.querySelector('.mfp-wrap .mfp-close');
    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');
    if (!dialog.hasAttribute('tabindex')) dialog.setAttribute('tabindex', '-1');

    if (close) {
      close.setAttribute('aria-label', 'Close Quick View');
      close.setAttribute('title', 'Close Quick View');
      window.setTimeout(function () { close.focus(); }, 20);
    } else {
      window.setTimeout(function () { dialog.focus(); }, 20);
    }
  }

  function initQuickViewAccessibility() {
    if (quickViewEventsBound) return;
    quickViewEventsBound = true;

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('.quick-view-btn');
      if (trigger) quickViewTrigger = trigger;
    }, true);

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Tab') return;
      var popup = document.querySelector('.mfp-wrap .quick-view-panel');
      if (!popup) return;

      var content = popup.closest('.mfp-content') || popup;
      var elements = focusableElements(content);
      if (!elements.length) return;
      var first = elements[0];
      var last = elements[elements.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    if (window.jQuery) {
      window.jQuery(document)
        .on('mfpOpen.bpcCollection mfpAjaxContentAdded.bpcCollection', enhanceQuickView)
        .on('mfpClose.bpcCollection', function () {
          if (quickViewTrigger && document.documentElement.contains(quickViewTrigger)) {
            window.setTimeout(function () { quickViewTrigger.focus(); }, 20);
          }
        });
    }
  }

  function initQuickViewCartTransition() {
    if (window.Shopify && window.Shopify.bpcQuickViewCartTransitionWrapped) return;

    if (!window.Shopify || typeof window.Shopify.showModal !== 'function' ||
        !window.jQuery || !window.jQuery.magnificPopup) {
      if (!quickViewCartTransitionTimer && quickViewCartTransitionAttempts < 40) {
        quickViewCartTransitionAttempts += 1;
        quickViewCartTransitionTimer = window.setTimeout(function () {
          quickViewCartTransitionTimer = null;
          initQuickViewCartTransition();
        }, 50);
      }
      return;
    }

    quickViewCartTransitionAttempts = 0;

    var originalShowModal = window.Shopify.showModal;
    var transitionPending = false;

    window.Shopify.showModal = function () {
      var popup = window.jQuery.magnificPopup.instance;
      var quickView = document.querySelector('.mfp-wrap .quick-view-panel');
      var context = this;
      var args = arguments;

      if (!quickView || !popup || !popup.isOpen) {
        return originalShowModal.apply(context, args);
      }

      if (transitionPending) return;
      transitionPending = true;

      var cartOpened = false;
      var openCart = function () {
        if (cartOpened) return;
        cartOpened = true;
        transitionPending = false;
        window.jQuery(document).off('mfpAfterClose.bpcQuickViewCart');
        originalShowModal.apply(context, args);
      };

      window.jQuery(document).one('mfpAfterClose.bpcQuickViewCart', openCart);
      popup.close();

      /* Fall back only if another script prevents Magnific Popup's after-close event. */
      window.setTimeout(openCart, 1400);
    };

    window.Shopify.bpcQuickViewCartTransitionWrapped = true;
  }

  function initialize(scope) {
    var collections = [];
    if (scope.matches && scope.matches('[data-bpc-collection]')) collections.push(scope);
    collections = collections.concat(Array.prototype.slice.call(scope.querySelectorAll('[data-bpc-collection]')));

    collections.forEach(function (collection) {
      initDescription(collection);
      initCollectionSubnav(collection);
      initLoadMore(collection);
    });
    initQuickViewAccessibility();
    initQuickViewCartTransition();
  }

  function ready() {
    initialize(document);
    document.addEventListener('shopify:section:load', function (event) {
      initialize(event.target || document);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
})();
